import { broadcastQueryClient } from "@tanstack/query-broadcast-client-experimental";

export const QUERY_BROADCAST_CHANNEL = "doctolik-query-cache-v1";

export const defaultBroadcastOptions = {
  broadcastChannel: QUERY_BROADCAST_CHANNEL,
};

/** Keep a QueryClient synchronized with other same-origin browser tabs. */
export function startQueryBroadcast(queryClient, options = defaultBroadcastOptions) {
  if (!queryClient || typeof window === "undefined") return () => {};

  return broadcastQueryClient({
    queryClient,
    ...options,
  });
}
